import React, { useEffect, useState } from 'react';
import "./styles/index.scss"
import { useDispatch, useSelector } from "react-redux";
import { loadNotificationsPropsSaga, dismissNotificationPropsSaga } from "../../sagas/notifications/types";
import { AppState } from "../../store";
import { MDBCol, MDBRow, MDBIcon, MDBCard, MDBCardBody, MDBCardText } from 'mdbreact';
import INotification from "../../dtos/INotification"
import { useBottomScrollListener } from 'react-bottom-scroll-listener';

interface INotificationsListProps {
}
export default function NotificationsList() {
    const dispatch = useDispatch();
    const [page, updatePage] = useState(0);
    const notificationsReducer = useSelector((state: AppState) => state.notificationsReducer)
    const loadMore = () => {
        dispatch(loadNotificationsPropsSaga(false, page + 1, 10))
        updatePage(page + 1)
    }
    useEffect(() => {
        dispatch(loadNotificationsPropsSaga(false, page, 10))
    }, []);
    useBottomScrollListener(loadMore);
    return (
        <MDBRow className="m-4 justify-content-center w-100">
                {notificationsReducer.notifications.length > 0 ?
                    notificationsReducer.notifications.map((n: INotification, index: any) => {
                        return <MDBRow className="mr-5 ml-5 cart-card w-100">
                            <MDBCol>
                                <MDBCard className="card-shadow">
                                    <MDBCardBody>
                                        <MDBRow>
                                            <MDBCol>
                                                <MDBCardText tag="h4" className="text-center font-weight-bold cart-text p-1">{n.title}</MDBCardText>
                                            </MDBCol>
                                            <MDBIcon icon="times-circle" className="justify-content-end pr-3 notification-icon"
                                                onClick={() => dispatch(dismissNotificationPropsSaga(n.uuid))}
                                                title="Dismiss"
                                            ></MDBIcon>
                                        </MDBRow>
                                        <MDBRow>
                                            <MDBCol>
                                                <MDBCardText tag="h4" className="font-weight-bold p-1">{n.long_description}</MDBCardText>
                                            </MDBCol>
                                        </MDBRow>
                                        <MDBRow>
                                            <MDBCol>
                                                <MDBCardText tag="h4" className="font-weight-bold p-1">{n.notification_date}</MDBCardText>
                                            </MDBCol>
                                        </MDBRow>
                                    </MDBCardBody>
                                </MDBCard>
                            </MDBCol>
                        </MDBRow>
                    })
                    :
                    <div>You don't have any notifications yet</div>
                }
        </MDBRow >

    )
}
